import { EmptyList as UIEmptyList, EmptyListProps as UIEmptyListProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type Props = Omit<UIEmptyListProps, 'defaultText' | 'defaultPressableText'>;

const EmptyList = (props: Props) => {
    const { t } = useTranslation();
    return (
        <UIEmptyList
            defaultText={t('components.emptyList.defaultText')}
            defaultPressableText={t('components.emptyList.defaultPressableText')}
            {...props}
        />
    );
};

export default EmptyList;
